import { Link } from 'react-router-dom';
import styled from 'styled-components'
import { mainColor, mainFont } from '../../styles/global';


export const SavingsWrapper = styled.div`
    padding:3% 7%;
      
`;

export const SavingsHeader = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    gap:3rem;
    // height:100vh; 
    height:fit-content;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap:0rem;
        height:fit-content;
    }
`;


export const RightSection = styled.div`
    flex:0.5;
    margin-top:80px;
    img{
        height:90%;
        width:90%;
    }
    @media screen and (max-width: 768px) {
        display:flex;
        justify-content: center;
        align-items: center;
        img{
            height:80%;
            width:80%;
        }
    }
`;
export const  LeftSection = styled.div`
    flex:0.5;
    h3{
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 500;
        font-size: 46.5434px;
        line-height: 60px;
        // letter-spacing: 0.01em;
        color:${mainColor};
        margin-bottom:60px;
    }
    @media screen and (max-width: 768px) {
        h3{
            font-weight: 500;
            font-size: 27px;
            line-height: 33px;
        }
    }

`;
export const  NavLink = styled(Link)`
        background: #090458;
        border: 2px solid #090458;
        border-radius: 9px;
        color:#fff;
        text-decoration: none;
        padding: 12px 40px;
        margin:80px 0;
        @media screen and (max-width: 768px) {
            padding: 10px 30px;
            font-size:12px;
        }
`;

export const TextBox = styled.div`
    width:80%;
    margin:auto;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction: column;
    margin:70px auto;
    p{
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 400;
        font-size: 17px;
        line-height: 26px;
        text-align: justify;
        letter-spacing: 0.01em;
        color: #8D8D8D;
    }
    @media screen and (max-width: 768px) {
        width:100%;
        margin-top:80px;
        p{
            font-family: ${mainFont};
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            text-align: justify;
            letter-spacing: 0.01em;
            color: #8D8D8D;
        }
    }
`;
export const SavingsTextHeader = styled.div`
        font-family: ${mainFont};
        font-style: normal;
        font-weight: 500;
        font-size: 46.5434px;
        width:70%;
        text-align: center;
        letter-spacing: 0.01em;
        color: ${mainColor};
        margin:5rem auto 0 auto;
        @media screen and (max-width: 768px) {
            font-weight: 600;
            width:90%;
            font-size: 18px;
            line-height: 34px;
            text-align: center;
            margin:2rem auto 0 auto;
          
        }
`;

export const SavingsGridBox = styled.div`
        display:flex;
        justify-content:center;
        align-items: center;
        gap:2rem;
        flex-wrap: wrap;
        margin-top:4rem;
        @media screen and (max-width: 768px) {
            flex-direction: column;
            margin-top:2rem;
            gap:1rem;


        }

`;

export const StoryBox = styled.div`
        width:calc(50% - 2rem);
        padding:3% 5%;
        background:#FDF2F5;
        border-radius: 9px;
        min-height: 300px;
        margin-top:20px;
        position:relative;
        > div{
            text-align:right;
            margin-top:10px;
            position:absolute;
            bottom:10px;
            right:10px;

        }
        >h3{
            font-family:${mainFont};
            color:${mainColor};
            font-style: normal;
            font-weight: 750;
            font-size: 36px;
            line-height: 63px;
            letter-spacing: 0.01em;
            margin-bottom:10px;
        }
        p{
            font-family: 'Avenir';
            font-style: normal;
            font-weight: 400;
            font-size: 17px;
            line-height: 26px;
            letter-spacing: 0.01em;
            color: #8D8D8D;
        }
        @media screen and (max-width: 768px) {
            width:100%;
            margin-top:0;
            padding:5% 5%;
            min-height: 180px;

            h3 {
                font-size: 21.3844px;
                line-height: 26px;
            }
          
            p{
                font-family: 'Avenir';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 18px;
                letter-spacing: 0.01em;
                color: #8D8D8D;
            }
        }

`;
export const  LearnMore = styled(Link)`
        text-decoration: none;
        color:${mainColor};
       
        @media screen and (max-width: 768px) {
            
        }
`;
